import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  UserPermissionCreateRequestDTO,
  UserPermissionUpdateRequestDTO,
  UserPermissionDeleteRequestDTO,
  UserPermissionReadByIdRequestDTO,
  UserPermissionReadByFeatureIdRequestDTO,
  UserPermissionReadByUserIdRequestDTO,
  UserPermissionReadBySubRoleIdRequestDTO,
  UserPermissionDTO,
  UserPermissionList,
  UserPermissionReadBySoftwareIdRequestDTO,
  UserPermissionAccessDTO
} from './userPermission.interface';

import {
  UserPermission_create,
  UserPermission_update,
  UserPermission_delete,
  UserPermission_readAll,
  UserPermission_readById,
  UserPermission_readByFeatureId,
  UserPermission_readByUserId,
  UserPermission_readBySubRoleId,
  UserPermission_readBySoftwareId
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionService {

  constructor(private http: HttpClient) { }
  UserPermissions: BehaviorSubject<UserPermissionAccessDTO[]> = new BehaviorSubject<UserPermissionAccessDTO[]>([]);

  getUserPermission(code: string): boolean {
    const permission = this.UserPermissions.value.find(i => i.fCode == code);
     return permission ? permission.fAccess == 1 : false;
  }
  UserPermission_create(data: UserPermissionCreateRequestDTO): Observable<UserPermissionDTO> {
    return this.http.post<UserPermissionDTO>(UserPermission_create, data);
  }

  UserPermission_update(data: UserPermissionUpdateRequestDTO): Observable<UserPermissionDTO> {
    return this.http.post<UserPermissionDTO>(UserPermission_update, data);
  }

  UserPermission_delete(data: UserPermissionDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(UserPermission_delete, data);
  }

  UserPermission_readAll(): Observable<UserPermissionList> {
    return this.http.get<UserPermissionList>(UserPermission_readAll);
  }

  UserPermission_readById(data: UserPermissionReadByIdRequestDTO): Observable<UserPermissionDTO> {
    return this.http.post<UserPermissionDTO>(UserPermission_readById, data);
  }

  UserPermission_readByFeatureId(data: UserPermissionReadByFeatureIdRequestDTO): Observable<UserPermissionList> {
    return this.http.post<UserPermissionList>(UserPermission_readByFeatureId, data);
  }

  UserPermission_readBySoftwareId(data: UserPermissionReadBySoftwareIdRequestDTO): Observable<UserPermissionList> {
    return this.http.post<UserPermissionList>(UserPermission_readBySoftwareId, data);
  }

  UserPermission_readByUserId(data: UserPermissionReadByUserIdRequestDTO): Observable<{items:UserPermissionAccessDTO[]}> {
    return this.http.post<{items:UserPermissionAccessDTO[]}>(UserPermission_readByUserId, data);
  }

  UserPermission_readBySubRoleId(data: UserPermissionReadBySubRoleIdRequestDTO): Observable<UserPermissionList> {
    return this.http.post<UserPermissionList>(UserPermission_readBySubRoleId, data);
  }
}
